
import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Close, Create, FileCopySharp } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { useParams } from 'react-router-dom';
import Badge from 'components/Badge/Badge';

//servicios
import { wsGet, wsUpdate, wsFindBy } from 'services/WService.js';

//modal
import Modal from './Modal';
import Modal2 from './ModalUpdate';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 160 },
  { Header: 'Grupo Incentivo', accessor: 'grupo'},
  { Header: 'Zona', accessor: 'base_zone_description'},
  { Header: 'Mesa', accessor: 'base_bureau_description'},
  { Header: 'Canal', accessor: 'base_canal_description'},
  { Header: 'Incentivo vendedor', accessor: 'incentivo_vendedor'},
  { Header: 'Incentivo supervisor', accessor: 'incentivo_supervisor'},
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];
const permission = {
  store: 'INCENTIVOS_TIPO_INCENTIVOS_STORE',
  delete: 'INCENTIVOS_TIPO_INCENTIVOS_DELETED',
  update: 'INCENTIVOS_TIPO_INCENTIVOS_UPDATE',
};
export default WithApp(function SaleForceDetail(props) {
  const classes = useStyles();
  const [dataLoading, setDataLoading] = useState(false);

  const { id, showNotify, giCanals, setGICanals, reload, grupoIncentivo } = props;
  const [model, setOpen] = useModal();
  const [model2, setOpen2] = useModal();

  const handleChange = (id, field, value) => {
    const index = giCanals.findIndex((item) => item.id == id);
    giCanals[index][field] = value;
    setGICanals([...giCanals]);
  };

  async function updateCuota(id, field, value) {
    setDataLoading(true);
    let response = await wsUpdate('sale/grupo-incentivo-canal', id, { [field]: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      console.log('Datos devueltos: ', response.data)
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  return (
    <>
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={reload}
          grupos_incentivos={grupoIncentivo}
        />
      ) : undefined}
      {model2.open ? (
        <Modal2 
          model={model2}
          setOpen={setOpen2}
          showNotify={showNotify}
          reload={reload}
          grupos_incentivos={grupoIncentivo}
        />
      ) : undefined}
      <Card>
        <CardHeader icon>
          <AllowedGuard permission={ConstantPermissions[permission.store]}
            component={
              <CardIcon color="primary">
                <FileCopySharp style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <CardIcon
              onClick={() => setOpen({})}
              pointer="true"
              color={props.themeContext.buttonColorSuccess}
            >
              <Add />
            </CardIcon>
          </AllowedGuard>
          <h4 className={classes.cardIconTitle}>Listado de grupos de incentivos detallado
          <span style={{ fontSize: '14px' }}>
            <b>{` (${grupoIncentivo.description || ''})`}</b>
          </span>
          {dataLoading && <LoadingSpinner />}
          </h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName="cuotas_categoria_colgate"
            defaultWidth={700}
            columns={columns}
            data={
              giCanals?.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen2(item)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions[permission.delete]}>
                          <Button
                            justIcon
                            round
                            simple
                            onClick={() => {
                              props.confirm('sale/grupo-incentivo-canal', item.id, reload);
                            }}
                            color={props.themeContext.buttonColorDanger}
                            className="remove"
                          >
                            <Close />
                          </Button>
                      </AllowedGuard>
                    </div>
                  ),
                  grupo: item.grupo,
                  base_zone_description: item.base_zone_description,
                  base_bureau_description: item.base_bureau_description,
                  base_canal_description: item.base_canal_description,
                  incentivo_vendedor: (
                    <AllowedGuard permission={ConstantPermissions[permission.update]}
                      component={item.incentivo_vendedor}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="incentivo_vendedor"
                        margin="normal"
                        value={item.incentivo_vendedor || ''}
                        onChange={(e) => handleChange(item.id, 'incentivo_vendedor', e.target.value)}
                        onBlur={(e) => updateCuota(item.id, 'incentivo_vendedor', e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  incentivo_supervisor: (
                    <AllowedGuard permission={ConstantPermissions[permission.update]}
                      component={item.incentivo_supervisor}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="incentivo_supervisor"
                        margin="normal"
                        value={item.incentivo_supervisor || ''}
                        onChange={(e) => handleChange(item.id, 'incentivo_supervisor', e.target.value)}
                        onBlur={(e) => updateCuota(item.id, 'incentivo_supervisor', e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  actions: '',
                };
              }) || []
            }
          />
        </CardBody>
      </Card>
    </>
  );
});
